import React, { Component } from "react";
import PropTypes from "prop-types";
import { formatDate } from "@ufginsurance/ui-kit";
import { Translations } from "./translations/Translations";
import AutoId from "./account-summary-v2/AutoId";
import orderBy from "lodash.orderby";

class AutoIdCardsTable extends Component {
  static propTypes = {
    autoIdCardAccounts: PropTypes.arrayOf(PropTypes.object).isRequired
  };

  state = {};

  orderAccountsAndPolicies(autoIdCardAccounts) {
    let orderedAccounts = orderBy(
      autoIdCardAccounts,
      policy => policy.account_number,
      "desc"
    );
    orderedAccounts = orderedAccounts.reduce((acc, policy) => {
      const filteredAccount = acc.filter(
        _policy => _policy.account_number === policy.account_number
      );

      if (filteredAccount.length === 0) {
        acc.push({
          account_number: policy.account_number,
          policies: [{ ...policy }]
        });
      } else {
        filteredAccount[0].policies.push({
          policy_number: policy.policy_number,
          policy_nickname: policy.policy_nickname,
          policy_type: policy.policy_type,
          auto_id_link: policy.auto_id_link,
          process_date: policy.process_date,
          effective_date: policy.effective_date
        });
      }
      return acc;
    }, []);
    return orderedAccounts.map(account => {
      orderBy(account.policies, policy => policy.policy_number, "desc");
      return account;
    });
  }

  render() {
    const { autoIdCardAccounts } = this.props;
    return (
      <table className="table">
        <thead style={{ textTransform: "none" }}>
          <tr>
            <td key="1">Account</td>
            <td key="2">Policy</td>
            <td key="3">Process Date</td>
            <td key="4">Document Type</td>
            <td key="5">Effective Date</td>
          </tr>
        </thead>
        <tbody>
          {this.orderAccountsAndPolicies(autoIdCardAccounts).map(account =>
            account.policies.map(policy => (
              <tr key={policy.policy_number}>
                <td>{account.account_number}</td>
                <td>
                  {`${policy.policy_number} - ${
                    policy.policy_nickname ||
                    (Translations.policy_types[policy.policy_type] ??
                      policy.policy_type)
                  }`}
                </td>
                <td>
                  {policy.process_date
                    ? formatDate(policy.process_date, "MM/DD/YYYY")
                    : ""}
                </td>
                <td>
                  <AutoId autoIdLink={policy.auto_id_link} />
                </td>
                <td>
                  {policy.effective_date
                    ? formatDate(policy.effective_date, "MM/DD/YYYY")
                    : ""}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    );
  }
}

export default AutoIdCardsTable;
